<div class="mb-6">
    @if (title() || (showRequiredMarker() && isRequired())) {
        <div class="mb-2 flex items-center gap-4">
            <div class="text-xl font-semibold">
                {{ title() | translate }}{{ showRequiredMarker() && isRequired() ? '*' : '' }}
            </div>
        </div>
    }

    <div [formGroup]="internalGroup">
        <tran-custom-value-select-field
            formControlName="selection"
            [options]="subjectAreas()"
            [readonly]="readonly()"
            [label]="label()"
            [required]="showRequiredMarker() && isRequired()"
            [errorMapper]="isRequired() ? { required: 'application-form.selected-area-min1' | translate } : {}"
        />
    </div>
</div>
